import { useState } from "react";
import { toast } from "sonner";
import { User } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { useAuthedApi, errMsg, imgUrl } from "../lib/api";
import { useSite } from "../lib/site";
import ImageUploader from "./ImageUploader";
import BackButton from "./BackButton";

const FIELDS = [["name", "Name", 60], ["age", "Age", 3], ["location", "Location", 80], ["title", "Title", 60], ["whatsapp", "WhatsApp number (with 91)", 13]];
const AREAS = [["quote", "Quote", 300], ["goal", "Goal", 600], ["mission", "Mission", 600]];

export default function OwnerEditor({ onClose }) {
  const api = useAuthedApi();
  const { owner, setOwner } = useSite();
  const [f, setF] = useState(owner);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!/^[0-9]{10,13}$/.test(f.whatsapp)) return toast.error("WhatsApp number: digits only, e.g. 918605593941");
    setBusy(true);
    try { setOwner(await api("put", "/admin/settings/owner", f)); toast.success("Owner profile updated"); onClose(); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#0b1630] border-[#D4AF37]/40 text-white sm:max-w-2xl max-h-[92vh] overflow-y-auto" data-testid="owner-editor">
        <DialogHeader><DialogTitle className="font-display text-3xl gold-text">Edit owner profile</DialogTitle></DialogHeader>
        <div><BackButton onClick={onClose} testid="owner-editor-back" /></div>
        <div className="flex flex-wrap gap-5 items-start">
          <div className="w-28 shrink-0"><ImageUploader value={f.photo_url ? [f.photo_url] : []} onChange={(fn) => setF((p) => ({ ...p, photo_url: fn(p.photo_url ? [p.photo_url] : []).slice(-1)[0] || "" }))} max={1} testid="owner-photo" /></div>
          <div className="flex items-center gap-3" data-testid="owner-editor-preview">
            <div className="w-20 h-20 rounded-full overflow-hidden border-2 border-[#D4AF37] bg-[#132650] flex items-center justify-center">
              {f.photo_url ? <img src={imgUrl(f.photo_url)} alt="" className="w-full h-full object-cover" /> : <User className="w-8 h-8 text-[#D4AF37]" />}
            </div>
            <div><p className="font-display text-2xl gold-text">{f.name}</p><p className="text-xs text-blue-100/70">{f.title} · {f.location}</p></div>
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          {FIELDS.map(([k, l, m]) => <div key={k}><label className="lux-label">{l}</label><input className="lux-input" maxLength={m} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`owner-${k}`} /></div>)}
          {AREAS.map(([k, l, m]) => <div key={k} className="sm:col-span-2"><label className="lux-label">{l}</label><textarea className="lux-input min-h-[70px]" maxLength={m} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`owner-${k}`} /></div>)}
        </div>
        <div className="flex justify-end gap-2"><button className="btn-outline" onClick={onClose}>Cancel</button><button className="btn-gold" disabled={busy} onClick={save} data-testid="owner-save">{busy ? "Saving..." : "Save profile"}</button></div>
      </DialogContent>
    </Dialog>
  );
}
